import React, { useEffect } from "react";
import $ from 'jquery';

function Teaching0201() {
	useEffect(() => {
		if ($(window).width() < 767) {	// mobile時觸發
			//step_select-下拉選單:切換
			if ($("#step_select").length > 0) {
				$(".sb_m").css({ "display": "none", });
				$("#step01").css({ "display": "block", });
			}
			var step = "";
			var map = { "Step1": "step01", "Step2": "step02", "Step3": "step03", "Step4": "step04", "Step5": "step05", "Step6": "step06", "Step7": "step07", "Step8": "step08", "Step9": "step09", "Step10": "step10" };
			$("#step_select").bind("change", function () {
				var divId = map[this.value];
				document.getElementById("step01").style.display = "none";
				document.getElementById(divId).style.display = "";
				if (step !== "") {
					if (step !== divId) {
						document.getElementById(step).style.display = "none";
					}
				}
				step = divId;
			});
		}
	}, [])

	return (
		<div className="content_inpage">
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/container/teaching">教學&QA</a></li>
					<li><a href="/container/teaching/Teaching0201">Lucia & Lucia Mini</a></li>
				</ul>

				<h2 className="tit_main">Lucia &amp; Lucia Mini</h2>
				<div className="content_box">
					<select className="show_mobile" id="step_select" name="step_select">
						<option>Step1</option>
						<option>Step2</option>
						<option>Step3</option>
						<option>Step4</option>
						<option>Step5</option>
						<option>Step6</option>
						<option>Step7</option>
						<option>Step8</option>
						<option>Step9</option>
						<option>Step10</option>
					</select>
					<div className="steps steps_lucia">
						<div className="step_box sb_m" id="step01">
							<div className="sb_num"><span>Step1</span>下載 i 寶貝</div>
							<div className="sb_txt">
								<p>至Google Play(Android手機) 或App Store(iOS手機)搜尋「i寶貝+」或「 ibobby+」。</p>
							</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia01_w.jpg").default} alt="img_step_lucia01_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia01_m.jpg").default} alt="img_step_lucia01_m" /></div>
						</div>
						<div className="step_box sb_m" id="step02">
							<div className="sb_num"><span>Step2</span>登入中華電信會員</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia02_w.jpg").default} alt="img_step_lucia02_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia02_m.jpg").default} alt="img_step_lucia02_m" /></div>
						</div>
						<div className="steps steps_x3 steps_lucia sb_m" id="step03">
							<div className="sb_num"><span>Step3</span>音箱綁定(以LUCIA mini為例)</div>
							<p>其餘音箱型號綁定流程請參閱APP指引。</p><br />
							<div className="flex_set">
								<div className="step_box">
									<div className="sb_num"><span>1</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-01.jpg").default} alt="img_step_lucia03-01" /></div>
									<div className="sb_txt">
										<p>選擇設備種類</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>2</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-02.jpg").default} alt="img_step_lucia03-02" /></div>
									<div className="sb_txt">
										<p>選擇音箱種類</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>3</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-03.jpg").default} alt="img_step_lucia03-03" /></div>
									<div className="sb_txt">
										<p>將音箱插上電源</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>4</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-04.jpg").default} alt="img_step_lucia03-04" /></div>
									<div className="sb_txt">
										<p>同意使用條款</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>5</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-05.jpg").default} alt="img_step_lucia03-05" /></div>
									<div className="sb_txt">
										<p>將音箱進入網路設定模式</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>6</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-06.jpg").default} alt="img_step_lucia03-06" /></div>
									<div className="sb_txt">
										<p>允許開啟藍芽功能</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>7</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-07.jpg").default} alt="img_step_lucia03-07" /></div>
									<div className="sb_txt">
										<p>確認音箱網路設定模式燈號</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>8</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-08.jpg").default} alt="img_step_lucia03-08" /></div>
									<div className="sb_txt">
										<p>選擇Wi-Fi</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>9</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-09.jpg").default} alt="img_step_lucia03-09" /></div>
									<div className="sb_txt">
										<p>輸入Wi-Fi帳號密碼後下一步開始連線</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>10</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-10.jpg").default} alt="img_step_lucia03-10" /></div>
									<div className="sb_txt">
										<p>設備連線中</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>11</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-11.jpg").default} alt="img_step_lucia03-11" /></div>
									<div className="sb_txt">
										<p>設備連線成功</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>12</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-12.jpg").default} alt="img_step_lucia03-12" /></div>
									<div className="sb_txt">
										<p>輸入設備資訊</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>13</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia03-13.jpg").default} alt="img_step_lucia03-13" /></div>
									<div className="sb_txt">
										<p>音箱設備設定完成</p>
									</div>
								</div>
							</div>
						</div>
						<div className="step_box sb_m" id="step04">
							<div className="sb_num"><span>Step4</span>啟用服務</div>
							<div className="sb_txt">
								<p>啟用服務的方法，可依據不同綁約而有不同的啟用步驟。請參考下述說明，並選擇自己所需的啟用方法。</p>
							</div>
							<div className="sb_link flex_set">
								<a href="#step05" className="flex_box">行動4G/5G方案綁約<span>Step5</span></a>
								<a href="#step06" className="flex_box">光世代/MOD方案綁約<span>Step6</span></a>
								<a href="#step07" className="flex_box">單購空機方案<span>Step7</span></a>
							</div>
						</div>
						<div className="step_box sb_m" id="step05">
							<div className="sb_num"><span>Step5</span>啟用服務-行動4G/5G方案綁約</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia05_w.jpg").default} alt="img_step_lucia05_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia05_m.jpg").default} alt="img_step_lucia05_m" /></div>
						</div>
						<div className="steps steps_x3 steps_lucia sb_m" id="step06">
							<div className="sb_num"><span>Step6</span>啟用服務-光世代/MOD方案綁約</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia06_w.jpg").default} alt="img_step_lucia06_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia06_m.jpg").default} alt="img_step_lucia06_m" /></div>
						</div>
						<div className="steps steps_x3 steps_lucia sb_m" id="step07">
							<div className="sb_num"><span>Step7</span>啟用服務-單購空機方案</div>
							<div className="flex_set">
								<div className="step_box">
									<div className="sb_num"><span>1</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia07-01.png").default} alt="img_step_lucia07-01" /></div>
									<div className="sb_txt">
										<p>綁定完，從首頁點擊「我的 i 寶貝  (音箱名稱)」</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>2</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia07-02.png").default} alt="img_step_lucia07-02" /></div>
									<div className="sb_txt">
										<p>點擊「單購空機」</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>3</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia07-03.png").default} alt="img_step_lucia07-03" /></div>
									<div className="sb_txt">
										<p>勾選「同意」，點擊啟用。</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>4</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia07-04.png").default} alt="img_step_lucia07-04" /></div>
									<div className="sb_txt">
										<p>確認到期日期。</p>
									</div>
								</div>
								<div className="step_box">
									<div className="sb_num"><span>5</span></div>
									<div className="sb_img"><img src={require("../../image/img_step_lucia07-05.png").default} alt="img_step_lucia07-05" /></div>
									<div className="sb_txt">
										<p>至「技能開通」，查看體驗到期日。</p>
									</div>
								</div>
							</div>
						</div>
						<div className="step_box sb_m" id="step08">
							<div className="sb_num"><span>Step8</span></div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia08_w.png").default} alt="img_step_lucia08_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia08_m.png").default} alt="img_step_lucia08_m" /></div>
						</div>
						<div className="step_box sb_m" id="step09">
							<div className="sb_num"><span>Step9</span>內容服務聲控語句教學</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia09_w.jpg").default} alt="img_step_lucia09_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia09_m.jpg").default} alt="img_step_lucia09_m" /></div>
						</div>
						<div className="step_box sb_m" id="step10">
							<div className="sb_num"><span>Step10</span>APP功能介紹</div>
							<div className="sb_img show_web"><img src={require("../../image/img_step_lucia10_w.jpg").default} alt="img_step_lucia10_w" /></div>
							<div className="sb_img show_mobile"><img src={require("../../image/img_step_lucia10_m.jpg").default} alt="img_step_lucia10_m" /></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Teaching0201;